import React, { memo } from "react";
// import { Polyline } from "react-google-maps";
import { PolylineF } from "@react-google-maps/api";

const DisplayPolyline = (props) => {
  const { locations } = props;

  //console.log("DisplayPolyline.locations", locations);

  const pathCoordinates = () => {
    const filteredLocations = locations.filter(
      (item) =>
        Number(parseFloat(item.Latitude)) !== 0 &&
        Number(parseFloat(item.Longitude) !== 0)
    );

    return (
      filteredLocations &&
      filteredLocations.map((location) => {
        return {
          lat: Number(parseFloat(location.Latitude)),
          lng: Number(parseFloat(location.Longitude)),
        };
      })
    );
  };

  const setpolylineOption = () => {
    if (Highlight) {
      return {
        geodesic: true,
        strokeColor: "#ffaa89",
        strokeOpacity: 0.8,
        strokeWeight: 6,
        zIndex: 100,
      };
    }

    return {
      geodesic: true,
      //strokeColor: "#FF8E00",
      strokeColor: "#2196f3",
      strokeOpacity: 0.8,
      strokeWeight: 4,
      zIndex: 80,
    };
  };

  return <PolylineF path={pathCoordinates()} options={setpolylineOption()} />;
};

export default memo(DisplayPolyline);
